import React from 'react';

interface Props {
  Description: string;
}
const IntroSection = ({ Description }: Props) => {
  return (
    <div>
      <div className="CreateRepaymentPlan-introText">
        <p className="Text--medium">{Description}</p>
      </div>
      <div className="CreateRepaymentPlan-divider"></div>
    </div>
  );
};

export default IntroSection;
